import React from 'react';
import Icon from './Icon';
import styles from './Message.module.css';

export interface MessageProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
  /** Accessible label for the close button. Defaults to the Spanish "Cerrar alerta". */
  closeLabel?: string;
}

const Message: React.FC<MessageProps> = ({
  variant = 'info',
  title,
  children,
  onClose,
  className = '',
  closeLabel = 'Cerrar alerta',
}) => {
  const getIconName = () => {
    switch (variant) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      case 'info':
      default:
        return 'info';
    }
  };

  return (
    <div
      className={`uc-message ${variant} tie-border-${variant} ${styles.message} ${styles[variant]} ${className}`}
      role="alert"
    >
      {onClose && (
        <button
          className={`uc-message_close-button ${styles.closeButton}`}
          onClick={onClose}
          aria-label={closeLabel}
        >
          <Icon name="close" />
        </button>
      )}
      <div className={`uc-message_body ${styles.body}`}>
        {title && (
          <h2 className={`mb-24 ${styles.title}`}>
            <Icon name={getIconName()} className="warning-icon" /> {title}
          </h2>
        )}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default Message;
